import { render, staticRenderFns } from "./EmailVerificationBanner.vue?vue&type=template&id=fd25ff7e&"
import script from "./EmailVerificationBanner.vue?vue&type=script&lang=js&"
export * from "./EmailVerificationBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports